// https://github.com/apostrophecms/sanitize-html#htmlparser2-options
export const defaultSanitizeHtmlOptions = {
  allowedTags: [],
  allowedAttributes: {}
}
